import React from 'react';
import {Container, Row, Col, Button} from 'react-bootstrap';
import {Card} from 'react-bootstrap';
import Level3Title from '../../../../app/common/components/title/Level3Title';
import {useIntl} from 'react-intl';

const Outils = (): JSX.Element => {
  const intl = useIntl();

  return (
    <Container fluid className="mt-4 mb-5">
      <Card className="DetailsTelephonie col-12 col-xxl-6">
        <Card.Header>
          <Card.Title>
            <Level3Title title={intl.formatMessage({id: 'CONFIGURATION.TEL.OUTILS.TITLE'})} />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={12}>
              <h2>{intl.formatMessage({id: 'CONFIGURATION.TEL.OUTILS.SUBTITLE'})}</h2>
              <p>{intl.formatMessage({id: 'CONFIGURATION.TEL.OUTILS.DESC1'})}</p>
              <p>{intl.formatMessage({id: 'CONFIGURATION.TEL.OUTILS.DESC2'})}</p>

              <div className="my-4">
                <a href="https://myistra.ctx.celeste.fr/login" target="_blank" rel="noreferrer">
                  <Button variant="primary" size="lg">
                    {intl.formatMessage({id: 'CONFIGURATION.TEL.OUTILS.ACCESS_BUTTON'})}
                  </Button>
                </a>
              </div>

              <p>{intl.formatMessage({id: 'CONFIGURATION.TEL.OUTILS.GUIDE'})}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};
export default Outils;
